import { css } from '@emotion/react';
// import { DataSourcesQueries } from '@frontend/api-data-sources';
import { theme } from '@frontend/theme';
import { Heading, Table } from '@frontend/design-system';

type Props = {
  locationId: string;
};

type DataSource = {
  sourceName: string;
  status: string;
};
const dataSources = [] as DataSource[];
export const DataSources = ({ locationId: _locationId }: Props) => {
  // const { data: syncedDataSources } = DataSourcesQueries.useGetDataSourcesQuery(locationId);

  return (
    <>
      <div css={outline}>
        <header css={header}>
          <Heading level={3}>Data Sources</Heading>
        </header>
        <div
          css={css`
            .table {
              border: 0 !important;
              border-top-left-radius: 0;
              border-top-right-radius: 0;
            }
          `}
        >
          <Table
            data={dataSources}
            colConfig={[
              {
                Header: 'Name',
                id: 'name',
                accessor: (cell) => cell.sourceName,
              },
              {
                Header: 'Location Health',
                id: 'location-health',
                accessor: (cell) => cell.sourceName,
              },
              {
                Header: 'Sync Health',
                id: 'sync-health',
                accessor: (cell) => cell.status,
              },
            ]}
            rowActions={{
              actions: [],
            }}
          />
        </div>
      </div>
    </>
  );
};

const header = css`
  padding: ${theme.spacing(2)};
  background: ${theme.colors.neutral10};
  border-top-right-radius: ${theme.borderRadius.medium};
  border-top-left-radius: ${theme.borderRadius.medium};
`;

const outline = css`
  margin-top: ${theme.spacing(3)};
  border-radius: ${theme.borderRadius.medium};
  border: 1px solid ${theme.colors.neutral20};
`;
